import { Card, CardHeader, Row, Col } from "reactstrap";

import Header from "components/Headers/Header.js";
import { useGetAllPlans } from "lib/api-plans";
import { useGetAllTokens } from "lib/api-tokens";
import { useGetWithdrawRequests } from "lib/api-withdraw";
import { useGetAllUsers } from "lib/api-referral";

const Index = (props) => {
    const { data: allPlansData } = useGetAllPlans();
    const { data: allTokensData } = useGetAllTokens();
    const { data: withdrawlRequestsData } = useGetWithdrawRequests();
    const { data: allUsersData } = useGetAllUsers();

    const allUsers = allUsersData || [];
    const allPlans = allPlansData || [];
    const allTokens = allTokensData || [];
    const withdrawRequests = withdrawlRequestsData || [];

    const totalUsers = allUsers.length;
    const totalPlans = allPlans.length;
    const TotalTokens = allTokens.length;

    const pendingRequests = withdrawRequests.filter(
        (req) => req.status === "PENDING"
    ).length;

    const totalReferrals = allUsers.reduce(
        (sum, user) => sum + (user.referredCount || 0),
        0
    );

    const statsConfig = [
        {
            title: "Total Users",
            value: totalUsers,
            icon: "fas fa-users",
            bgColor: "bg-primary",
            size: "big",
        },
        {
            title: "Total Plans",
            value: totalPlans,
            icon: "fas fa-list",
            bgColor: "bg-success",
            size: "normal",
        },
        {
            title: "Total Tokens",
            value: TotalTokens,
            icon: "fas fa-coins",
            bgColor: "bg-warning",
            size: "normal",
        },
        {
            title: "Pending Requests",
            value: pendingRequests,
            icon: "fas fa-clock",
            bgColor: "bg-danger",
            size: "normal",
        },
        {
            title: "Total Referrals",
            value: totalReferrals,
            icon: "fas fa-share-alt",
            bgColor: "bg-info",
            size: "normal",
        },
    ];

    return (
        <>
            <Header />

            <div className="px-4">
                <Row className="mb-4 mt--6">
                    <Col xl="12" lg="12">
                        <Card className="card-stats mb-4">
                            <CardHeader>
                                <Row>
                                    <div className="col">
                                        <h5 className="card-title text-uppercase text-muted mb-0">
                                            {statsConfig[0].title}
                                        </h5>
                                        <span className="h1 font-weight-bold mb-0">
                                            {statsConfig[0].value}
                                        </span>
                                    </div>
                                    <div className="col-auto">
                                        <div
                                            className={`icon icon-shape ${statsConfig[0].bgColor} text-white rounded-circle shadow`}
                                            style={{
                                                width: "80px",
                                                height: "80px",
                                                lineHeight: "80px",
                                                fontSize: "2rem",
                                            }}
                                        >
                                            <i
                                                className={statsConfig[0].icon}
                                            />
                                        </div>
                                    </div>
                                </Row>
                            </CardHeader>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-4">
                    {statsConfig.slice(1).map((stat, index) => (
                        <Col xl="3" lg="" key={index + 1}>
                            <Card className="card-stats mb-4 mb-xl-0">
                                <CardHeader>
                                    <Row>
                                        <div className="col">
                                            <h5 className="card-title text-uppercase text-muted mb-0">
                                                {stat.title}
                                            </h5>
                                            <span className="h2 font-weight-bold mb-0">
                                                {stat.value}
                                            </span>
                                        </div>
                                        <div className="col-auto">
                                            <div
                                                className={`icon icon-shape ${stat.bgColor} text-white rounded-circle shadow`}
                                            >
                                                <i className={stat.icon} />
                                            </div>
                                        </div>
                                    </Row>
                                </CardHeader>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </div>
        </>
    );
};

export default Index;
